import { PortableText } from '@portabletext/react'
import { urlForImage } from 'lib/sanity.image'
import type { Settings } from 'lib/sanity.queries'
import Image from 'next/image'
import { Modules } from './Modules/Modules'

const TextComponents: any = {
  block: {
    normal: ({ children }) => (
      <p className="pb-24 text-14 leading-110 text-midGray last-of-type:pb-0">
        {children}
      </p>
    ),
  },
}

export default function HomePage(props: {
  preview?: boolean
  loading?: boolean
  title?: string
  content?: any
  settings: Settings
  modules?: any[]
  hero?: any
}) {
  const { modules, hero } = props
  const worldModule = modules?.find((module) => module._type === 'worldBlock')

  return (
    <div className="w-full bg-lightGray text-black">
      <div className="h-screen-s relative flex w-full flex-col justify-end p-20">
        {hero.mediaType === 'image' && hero.image ? (
          <Image
            src={urlForImage(hero.image).quality(90).auto('format').url()}
            fill
            alt=""
            style={{ objectFit: 'cover' }}
            placeholder="blur"
            sizes="100vw"
            priority
            className={`${hero.imageMobile?.url ? 'hidden md:block' : ''}`}
            blurDataURL={hero.image.lqip}
          />
        ) : null}
        {hero.mediaType === 'image' && hero.imageMobile ? (
          <Image
            src={urlForImage(hero.imageMobile).quality(90).auto('format').url()}
            fill
            alt=""
            style={{ objectFit: 'cover' }}
            placeholder="blur"
            sizes="100vw"
            priority
            className={`md:hidden`}
            blurDataURL={hero.imageMobile.lqip}
          />
        ) : null}
        {hero.mediaType === 'video' && hero.video.url ? (
          <video
            src={hero.video.url}
            autoPlay
            muted
            playsInline
            loop
            className={`absolute inset-0 h-full w-full object-cover ${
              hero.videoMobile?.url ? 'hidden md:block' : ''
            }`}
          />
        ) : null}
        {hero.mediaType === 'video' && hero.videoMobile?.url ? (
          <video
            src={hero.videoMobile.url}
            autoPlay
            muted
            playsInline
            loop
            className="absolute inset-0 h-full w-full object-cover md:hidden"
          />
        ) : null}
        <div className="z-1 relative max-w-[340px] rounded-8 bg-white p-[15px] text-13 leading-110 text-darkGray">
          <PortableText value={hero.heading} components={TextComponents} />
        </div>
      </div>
      {modules ? <Modules modules={modules} /> : null}
    </div>
  )
}
